(function () {
    "use strict";

    angular.module("app").filter("fileSize", function FileSizeFilterFactory() {
        return function (size) {
            const base = 1024;
            const prefixes = ["Ki", "Mi", "Gi", "Ti", "Pi", "Ei", "Zi", "Yi"];

            const exp = Math.log(size) / Math.log(base) | 0;

            let unit = "Bytes";
            if (exp > 0) {
                unit = prefixes[exp - 1] + "B";
            }

            return (size / Math.pow(base, exp)).toFixed(1) + " " + unit;
        };
    });
})();
